module.exports = __webpack_public_path__ + "static/logo-73b1337c100bffa6a37a2cdbd6e21971.png";